import React, {Fragment} from 'react';

import {Box, Grid} from '@material-ui/core';

import {
    StyledTableCell,
    StyledTableCellWithoutSize,
} from 'components/efe-table/efe-table-components/table-helpers';
import {EfeButtonPrimary} from 'components/buttons';
import {Check} from '@material-ui/icons';
import {Column, TableAction} from 'commons/models/components/EfeTableValues';

type Props = {
    column: Column;
    data: any;
    index: number;
    minWidth: boolean;
    handleAction?: (action: TableAction) => void;
};

function EfeCellTable(props: Props) {
    const {index, column, data, minWidth, handleAction} = props;

    function cell(column: Column, data: any) {
        if (column.cellType === 'text') {
            return (
                <Box display='flex' flexDirection='row' justifyContent='center' mt={2}>
                    <Grid container spacing={2} justifyContent={'space-between'}>
                        {column.cell(data)}
                    </Grid>
                </Box>
            );
        } else if (column.cellType === 'action' && handleAction) {
            return (
                <Box display='flex' flexDirection='row' justifyContent='center' mt={2}>
                    <Grid container spacing={2} justifyContent={'center'}>
                        <EfeButtonPrimary
                            onClick={() =>
                                handleAction({
                                    data: data,
                                    header: column.columnDef,
                                })
                            }
                            type='submit'
                            disabled={false}>
                            {column.actionDescription ? column.actionDescription : ''}
                            <Check />
                        </EfeButtonPrimary>
                    </Grid>
                </Box>
            );
        } else {
            return (
                <Box display='flex' flexDirection='row' justifyContent='center' mt={2}>
                    <Grid container spacing={2} justifyContent={'space-between'}>
                        Error. Tipo de celda no reconocido.
                    </Grid>
                </Box>
            );
        }
    }

    return (
        <Fragment>
            {minWidth && (
                <StyledTableCellWithoutSize component='td' scope='row' key={index}>
                    {cell(column, data)}
                </StyledTableCellWithoutSize>
            )}
            {!minWidth && (
                <StyledTableCell component='td' scope='row' key={index}>
                    {cell(column, data)}
                </StyledTableCell>
            )}
        </Fragment>
    );
}

export default EfeCellTable;
